import './onboarding-page-header.scss';

import { Space } from 'antd';

const text = {
  title: `Lets set up your profile`,
  body: `This will help your clinical team create the right treatment for your recovery`
};

export function OnboardingPageHeader() {
  return (
    <Space
      direction="vertical"
      className="onboarding-progress"
      style={{ textAlign: 'center' }}
    >
      <h2 style={{ marginBottom: '5px' }}>{text.title}</h2>
      <p className="onboarding-progress__description">{text.body}</p>
    </Space>
  );
}
